import React from 'react';
import './ContactSection.css'; 
import { IMAGES } from '../../assets/image'; 
import { CREDIT_UNION } from '../../assets/constants';

const ContactSection = () => {
  return ( 
    <section className="contact-section">
      <div className="layout-container">
        <h2 className="contact-heading">Need Assistance? We Are Here To Help!</h2>
        
        <div className="contact-content">
          <p className="contact-paragraph">
            We strive to make it as easy and convenient as possible for you to contact us and begin the process of refinancing your auto loan.
            Our dedicated representatives are ready to assist you every step of the way, ensuring a smooth and efficient experience tailored to your needs.
          </p>

          <div className="contact-icons">
          <a href={CREDIT_UNION.LINKS.BRANCH_LOCATOR} className="contact-icon-link">
            <div className="contact-icon-block">
              <img src={IMAGES.BankIcon} alt="Find a Branch" className="contact-icon" />
              <p className="icon-title">Find a Branch</p>
            </div>
          </a>
         
          <a href={`tel:+${CREDIT_UNION.INFO.CONTACT}`} className="contact-icon-link">
            <div className="contact-phone-block">
              <img src={IMAGES.PhoneIcon} alt="Contact Us" className="contact-icon" />
              <p className="icon-title">Contact Us</p>
            </div>
          </a>


          {/* <a href={CREDIT_UNION.LINKS.BRANCH_LOCATOR} className="contact-icon-link">
            <div className="contact-appointment-block">
              <img src={IMAGES.AppointmentIcon} alt="Appointment" className="contact-icon" />
              <p className="icon-title">Appointment</p>
            </div>
          </a> */}
          </div>
        </div>

        <p className="contact-spanish">
          <em>
            Para hablar con uno de nuestros representantes en español por favor llámenos al 
            <a href='tel:+18009147536'><span className="phone-highlight"> 800-914-7536</span></a>.
          </em>
        </p>
      </div>
    </section>
  );
};

export default ContactSection;
